import { FileDropClassNames } from './useFileDrop';

export const CLASS_NAMES: FileDropClassNames = {
  wrapper: 'flex border px-6 py-8 rounded-lg shadow-card',
  processing: 'flex border border-neutral-300 px-6 py-8 rounded-lg shadow-card',
  error: 'text-red-200 text-12-18 mt-2',
};
